// Circular Bass Clef ship logo — used in the Header + Footer as the official brand mark.
import BassClefShip from "./BassClefShip";

export default function CircularBassClef({ size = 40 }) {
  return (
    <div
      className="relative rounded-full overflow-hidden shadow-[0_0_18px_rgba(212,175,55,0.35)] flex-shrink-0"
      style={{ width: size, height: size, background: "radial-gradient(circle at 40% 30%, #1a2f5c 0%, #0a1128 70%)" }}
      aria-hidden="true"
    >
      <div className="absolute inset-0 border border-[#D4AF37]/40 rounded-full pointer-events-none" />
      <BassClefShip />
    </div>
  );
}
